import React, { Component }  from 'react';
import { DatePicker, Button, Table, Form, Divider, message, Modal } from 'antd';
import axios from '../../service/index'
import ExportJsonExcel from "js-export-excel";
const { RangePicker } = DatePicker;
class ChannelIndex extends Component {

	constructor(props) {
		super(props)
		this.state = {
			columns: [
				{
					title: '信息量',
					children: [
						{
							title: '新增',
							dataIndex: 'djCount',
							key: 'djCount',
							align: 'center',
						},
						{
							title: '重量',
							dataIndex: 'djClCount',
							key: 'djClCount',
							align: 'center',
						}
					],
					align: 'center'
				},
				{
					title: '报名量',
					children: [
						{
							title: '新增',
							dataIndex: 'bmCount',
							key: 'bmCount',
							align: 'center',
						},
						{
							title: '重量',
							dataIndex: 'bmClCount',
							key: 'bmClCount',
							align: 'center',
						}
					],
					align: 'center'
				},
				{
					title: '进班量',
					children: [
						{
							title: '新增',
							dataIndex: 'jbCount',
							key: 'jbCount',
							align: 'center',
						},
						{
							title: '重量',
							dataIndex: 'jbClCount',
							key: 'jbClCount',
							align: 'center',
						}
					],
					align: 'center'
				},
				{
					title: '缴费量',
					children: [
						{
							title: '新增',
							dataIndex: 'jfCount',
							key: 'jfCount',
							align: 'center',
							render: (record) => <span style={{ color: '#277FFF', cursor: 'pointer' }} onClick={() => {
								this.setState({
									visible: true,
									flag: 1
								}, () => {
									this.getModelTableList()
								})
							}}>{record}</span>

						},
						{
							title: '重量',
							dataIndex: 'jfClCount',
							key: 'jfClCount',
							align: 'center',
							render: (record) => <span style={{ color: '#277FFF', cursor: 'pointer' }} onClick={() => {
								this.setState({
									visible: true,
									flag: 2
								}, () => {
									this.getModelTableList()
								})
							}}>{record}</span>
						}
					],
					align: 'center'
				},

			],
			modelColumns: [
				{
					title: '姓名',
					dataIndex: 'stuName',
					key: 'stuName',
					align: 'center',
					width: 120
				},
				{
					title: '电话',
					dataIndex: 'tel',
					key: 'tel',
					align: 'center',
					width: 120
				},
				{
					title: 'QQ',
					dataIndex: 'qq',
					key: 'qq',
					align: 'center',
					width: 120
				},
				{
					title: '登记时间',
					dataIndex: 'jfCount',
					key: 'jfCount',
					align: 'center',
					width: 120
				},
				{
					title: '撞单时间',
					dataIndex: 'clCreateTime',
					key: 'clCreateTime',
					align: 'center',
					width: 120
				},
				{
					title: '报名时间',
					dataIndex: 'applyTime',
					key: 'applyTime',
					align: 'center',
					width: 120
				},
				{
					title: '咨询师',
					dataIndex: 'kefuName',
					key: 'kefuName',
					align: 'center',
					width: 120
				},
				{
					title: '咨询师部门',
					dataIndex: 'kefuGroupName',
					key: 'kefuGroupName',
					align: 'center',
					width: 120
				},
				{
					title: '协助咨询师',
					dataIndex: 'kefuhelpName',
					key: 'kefuhelpName',
					align: 'center',
					width: 120
				},
				{
					title: '协助部门',
					dataIndex: 'kefuHelpGroupName',
					key: 'kefuHelpGroupName',
					align: 'center',
					width: 120
				},
				{
					title: '裂变人',
					dataIndex: 'realName',
					key: 'realName',
					align: 'center',
					width: 120
				},
				{
					title: '班级',
					dataIndex: 'className',
					key: 'className',
					align: 'center',
					width: 120
				},
				{
					title: '缴费金额',
					dataIndex: 'payment',
					key: 'payment',
					align: 'center',
					width: 120
				},
				{
					title: '缴费班级开班时间',
					dataIndex: 'payClassDate',
					key: 'payClassDate',
					align: 'center',
					width: 120
				},
				{
					title: '缴费班级',
					dataIndex: 'payClassName',
					key: 'payClassName',
					align: 'center',
					width: 120
				},
				{
					title: '进班时间',
					dataIndex: 'beginTime',
					key: 'beginTime',
					align: 'center',
					width: 120
				},
			],
			flag: '',
			tableList: [],
			modelTableList: [],
			startTime: '',
			endTime: '',
			dateValue: [null, null],
			modelTitle: '',
			visible: false
		}
	}
	componentDidMount() {
		console.log(this.props.location.state.id)
		this.getTableList()
	}
	componentWillUnmount() {

	}
	handleOk = (e) => {
		this.props.form.validateFields((err, values) => {
			console.log(err, values)
			let params = { ...values }
			params.shareUserId = values.shareUserId[1]

			if (!err) {
				if (this.state.modelTitle === '新增渠道') {
					axios.post('jumpUrlConfigController/addConfig', {
						...params
					}).then(res => {
						if (res.data.code === '200') {
							message.success('添加成功')
							this.getTableList()
							this.setState({
								visible: false
							})
						} else {
							message.error(res.data.msg)
						}
					})
					// } else {
					// 	axios.post('labelController/update', {
					// 		name: values.name,
					// 		id: this.state.labelId
					// 	}).then(res => {
					// 		console.log(res)
					// 		if (res.data.code === '200') {
					// 			message.success('编辑成功')
					// 			this.getTableList()
					// 			this.setState({
					// 				visible: false
					// 			})
					// 		} else {
					// 			message.error(res.data.msg)
					// 		}
					// 	})
				}

			}
		})
	}
	getTableList = () => {
		axios.post('userController/channelStatistical', {
			dateFrom: this.state.startTime,
			dateTo: this.state.endTime,
			source2Type: this.props.location.state.id
		}).then(res => {
			if (res.data.code === '200') {
				let arr = []
				arr.push(res.data.data)
				this.setState({
					tableList: arr
				})
			}
		})
	}
	getModelTableList = () => {
		axios.post('userController/channelStatisticalDetail', {
			flag: this.state.flag,
			dateFrom: this.state.startTime,
			dateTo: this.state.endTime,
			source2Type: this.props.location.state.id
		}).then(res => {
			if (res.data.code === '200') {
				let arr = []
				arr.push(res.data.data)
				this.setState({
					modelTableList: res.data.data
				})
			}
		})
	}
	getSubjectList = () => {
		axios.get('subjectController/getOption').then(res => {
			if (res.data.code === '200') {
				this.setState({
					subjectList: res.data.data
				})
			}
		})
	}
	getPageList = () => {
		axios.get('jumpUrlConfigController/getPageDetails').then(res => {
			if (res.data.code === '200') {
				this.setState({
					pageList: res.data.data
				})
			}
		})
	}
	getSourceType = () => {
		axios.get('jumpUrlConfigController/getSourceType').then(res => {
			if (res.data.code === '200') {
				this.setState({
					sourceTypeList: res.data.data
				})
			}
		})
	}
	getChannelType = () => {
		axios.get('jumpUrlConfigController/getChannelType').then(res => {
			if (res.data.code === '200') {
				this.setState({
					channelTypeList: res.data.data
				})
			}
		})
	}
	getAllTeachersByDepartment = () => {
		axios.get('userController/getAllTeachersByDepartment').then(res => {
			if (res.data.code === '200') {
				this.setState({
					residences: res.data.data
				})
			}
		})
	}
	handleCancel = () => {
		this.setState({
			visible: false,
			modelTableList: []
		})
	};
	createExcelData(columns) {
		let header = [], filter = [];
		for (let i = 0; i < columns.length; i++) {
			if (columns[i].key === "action") break;
			header.push(columns[i].title)
			filter.push(columns[i].key)
		}
		return {header, filter}
	}
	exportData() {
		let option = {};
		let obj = this.createExcelData(this.state.modelColumns);
		option.fileName =  '缴费量统计';
		option.datas = [
			{
				sheetData: this.state.modelTableList,
				sheetName: 'sheet1',
				sheetFilter: obj.filter,
				sheetHeader: obj.header,
			},
	
		];
		let toExcel = new ExportJsonExcel(option); //new
		toExcel.saveExcel();
	}
	render() {
		const { dateValue, tableList, visible, columns, modelColumns, modelTitle, modelTableList } = this.state
		return (
			<div className='channel-index'>
				<div style={{display: 'flex',justifyContent: 'space-between'}}>
					<span style={{ display: 'flex', alignItems: 'center', fontSize: '18px', fontWeight: '600' }}>数据详情</span>
					<span className="my-button-txt" onClick={()=>{
						this.props.history.go(-1)
					}}>返回上一级</span>
				</div>
				<Divider />
				<div style={{ display: 'flex', justifyContent: 'space-between' }}>
					<div style={{ display: 'flex', flexWrap: 'wrap' }}>
						<RangePicker size={'large'} value={dateValue} onChange={(date, dateString) => {
							console.log(date, dateString);
							this.setState({
								startTime: dateString[0],
								endTime: dateString[1],
								dateValue: date
							})
						}} />
						<Button className='my-button-primary' style={{ marginLeft: '20px' }} type='primary' onClick={() => {
							this.getTableList()
						}}>搜索</Button>
						<span className='my-button-txt' style={{ marginLeft: '20px', marginBottom: '20px' }} type='primary' onClick={() => {
							this.setState({
								dateValue: [null, null],
								startTime: '',
								endTime: '',
								searchData: {
									pageSize: 10,
									pageNum: 1,
								},
							})
						}}>重置</span>
					</div>
				</div>
				<Table
					dataSource={tableList}
					columns={columns}
					bordered
					rowKey={record => record}
					rowClassName={(record, index) => (index % 2 !== 0 ? 'table-line' : '')}
				/>
				<Modal
					width={1200}
					title={modelTitle}
					okText="确认"
					cancelText="取消"
					visible={visible}
					onOk={() => { this.handleOk() }}
					onCancel={() => { this.setState({ visible: false }) }}
					destroyOnClose
					zIndex={1000}
					maskClosable={false}
				>
					<div>
						<div style={{ display: 'flex', justifyContent: 'end', marginTop: '20px' }}>
							<Button className='my-button-primary' style={{ marginLeft: '20px', marginBottom: '20px' }} type='primary' onClick={() => {
								this.exportData()
							}}>导出</Button>
						</div>
						<div style={{ overflowY: 'auto' }}>
								<Table
									ref="table"
									pagination={false}
									dataSource={modelTableList}
									columns={modelColumns}
									bordered
									rowKey={record => record}
									rowClassName={(record, index) => (index % 2 !== 0 ? 'table-line' : '')}
								/>
						</div>
					</div>


				</Modal>
			</div>
		)
	}

};

export default Form.create()(ChannelIndex)